import {
  AbsoluteContainer,
  AppSpan,
  AppText,
  Button,
  Circle,
  CustomContainer,
  FlexColumn,
  FlexRow,
  GridContainer,
  Icon,
} from "src/style";
import { useContext, useEffect, useState } from "react";
import CbpTermsCondition from "./CbpTermsCondition";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { IoArrowBackOutline } from "react-icons/io5";
import { GiCheckMark } from "react-icons/gi";
import CbpConfirmDetails from "./CbpConfirmDetails";
import CbpVerifyDocument from "./CbpVerifyDocument.";
import CbpScreening from "./CbpScreening";

import CbpAccountCreated from "./CbpAccountCreated";
import UserContext from "src/provider/state-manager/userProvider";
import { CbpPin } from "./CbpPin";

interface StepperProps {
  steps: string[];
  currentStep: string;
}

interface CbpPopupProp {
  close: () => void;
}

const CbpOnboardingPopUp = ({ close }: CbpPopupProp) => {
  const [activeTab, setActiveTab] = useState("Terms");
  const OnboardingItems = ["Terms", "Confirm", "Pin", "Screening"];
  const {
    info: { institutionData },
  } = useContext(AppInfoContext);
  const [appLogo, setAppLogo] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (institutionData) setAppLogo(institutionData.logo);
  }, [institutionData?.logo]);

  const goForward = () => {
    const currentIndex = OnboardingItems.indexOf(activeTab);
    if (currentIndex < OnboardingItems.length - 1) {
      setActiveTab(OnboardingItems[currentIndex + 1]);
    }
  };

  const goBack = () => {
    const currentIndex = OnboardingItems.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(OnboardingItems[currentIndex - 1]);
    } else if (currentIndex === 0) {
      close();
    }
  };

  const renderItems = () => {
    switch (activeTab) {
      case "Terms":
        return (
          <CbpTermsCondition
            onNext={() => {
              goForward();
            }}
          />
        );
      case "Confirm":
        return (
          <CbpConfirmDetails
            onNext={() => {
              goForward();
            }}
          />
        );
      // case "Verify":
      //   return (
      //     <CbpVerifyDocument
      //       onNext={() => {
      //         goForward();
      //       }}
      //     />
      //   );
      case "Screening":
        return (
          <CbpScreening
            onNext={() => {
              goForward();
            }}
          />
        );
      case "Pin":
        return (
          <CbpPin
            onNext={() => {
              goForward();
            }}
          />
        );

      case "Created":
        return <CbpAccountCreated />;
      default:
        return null;
    }
  };

  return (
    <FlexColumn justifyContent="center" alignItems="center">
      <FlexRow justifyContent="space-between" align="center" bottomMargin="2">
        <AppSpan
          color="#344054"
          textSize="1.6"
          onClick={() => {
            goBack();
          }}
        >
          <IoArrowBackOutline />
        </AppSpan>
        {appLogo ? (
          <Icon src={appLogo} className="app-logo-icon" height="5" width="5" />
        ) : null}
      </FlexRow>

      {!isMobile && activeTab !== "Terms" && (
        <FlexRow>
          <Stepper steps={OnboardingItems} currentStep={activeTab} />
        </FlexRow>
      )}
      <CustomContainer>{renderItems()}</CustomContainer>
    </FlexColumn>
  );
};

export default CbpOnboardingPopUp;

const Stepper = ({ steps, currentStep }: StepperProps) => {
  const currentIndex = steps.indexOf(currentStep);

  return (
    <GridContainer>
      <FlexRow>
        <AbsoluteContainer top="1.3" width="90" sizeUnit="%">
          <GridContainer>
            <CustomContainer
              width="85"
              sizeUnit="%"
              height="0.2"
              bgColor="#EAECF0"
            />
          </GridContainer>
        </AbsoluteContainer>
        {steps?.map((item: any, index: any) => (
          <FlexRow alignItems="center" key={index}>
            {/* cirle and text */}
            <GridContainer width="9" style={{ zIndex: "2" }}>
              <Circle
                size="2.4"
                bottomMargin="1.3"
                bgColor={"#E7F6F5"}
                borderColor={"#F4EBFF"}
                borderWidth={"1"}
              >
                {index < currentIndex ? (
                  <AppSpan textSize="1.2" color="#FFFFFF">
                    <GiCheckMark />
                  </AppSpan>
                ) : index === currentIndex ? (
                  <Circle size="0.8" bgColor={"#0D968F"} />
                ) : (
                  <Circle size="0.8" bgColor={"#FFFFFF"} />
                )}
              </Circle>
              <AppText
                fontWeight="600"
                color={index <= currentIndex ? "#0A756F" : "#999"}
              >
                {item}
              </AppText>
            </GridContainer>
          </FlexRow>
        ))}
      </FlexRow>
    </GridContainer>
  );
};
